// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1RFJQ","productName":"Table_productName__2gp8k"};